export default {
	namespaced: true,
	state:{
		step: 0,
		loading: false,
		finishing: false,
		listToHighlight: [],
		bottomButtons: {
			showBottomButtons: true,
			showSkip: false,
			blockNext: false
		},
		components: [
			{
				step: "StepWizardIntegrations",
				title: "Integrações"
			},
			{
				step: "StepWizardSegments",
				title: "Área de atuação"
			},
			{
				step: "StepWizardWhatsapp",
				title: "Telefone"
			},
			{
				step: "StepWizardCommercialName",
				title: "Nome do site"
			},
			{
				step: "StepWizardAbout",
				title: "Sobre"
			},
			{
				step: "StepWizardBlog",
				title: "Novidades"
			},
			{
				step: "StepWizardContact",
				title: "Contato"
			},
			{
				step: "StepWizardHighlight",
				title: "Destaque da Home"
			},
			{
				step: "StepWizardTestimony",
				title: "Depoimentos"
			},
			{
				step: "StepWizardThemes",
				title: "Escolha um tema"
			},
			{
				step: "StepWizardLogoConfig",
				title: "Logo no site"
			}
		],
		segments: [],
		subsegments: [],
		dataSite: {
			createTime: {
				startTime: null,
				finishTime: null
			},
			siteId: null,
			siteName: "",
			siteUrl: "",
			segment: "",
			selectedSubsegments: [],
			posts: [],
			novidades: [],
			servicos: [],
			portfolio: [],
			createdItems: [],
			testimonies: [],
			whatsappIdd: 30,
			whatsappNumber: "",
			template: 10,
			customSchema: {},
			themeMode: "light",
			profilePicture: "",
			logoSelected: null,
			listLogo: [],
			avatarPicture: "",
			logoPicture: "",
			aboutSetup: {
				images: [],
				style: null,
				aboutList: [],
				selected: {
					content: null,
					id: null
				}
			},
			contactSetup: {
				images: [],
				showWhatsapp: false,
				showMap: false,
				showTelephone: true
			},
			cities: [],
			allImages: [],
			highlights: []
		}
	},
	getters:{

	},
	mutations:{

	},
	actions:{

	}
}


// WEBPACK FOOTER //
// ./src/store/modules/wizardModule.js